import type { Room } from '../types/room';
import room1Img from '../assets/img/room1-point3d-commercial-imaging-ltd-5BV56SdvLmo-unsplash.jpg';
import room2Img from '../assets/img/room2-point3d-commercial-imaging-ltd-oxeCZrodz78-unsplash.jpg';
import room3Img from '../assets/img/room3-reisetopia-aI6Su7Mu9Ro-unsplash.jpg';
import room4Img from '../assets/img/room4-vojtech-bruzek-Yrxr3bsPdS0-unsplash.jpg';

export type HotelSeedRoom = Room;

export type HotelSeedItem = {
  id: string;
  name: string;
  stars: number;
  bedType: string;
  price: string;
  currency?: string;
  breakfastIncluded: boolean;
  image: string;
  images?: string[];
  rooms: HotelSeedRoom[];
  __renderDetailCard?: boolean;
  location?: string;
  rating?: number;
  ratingLabel?: string;
  pricePerNight?: number;
  totalPrice?: number;
  nights?: number;
  amenities?: string[];
  description?: string;
  category?: string;
  roomsTotal?: number;
  priceBands?: Array<{ band: number; min: number; max: number }>;
};

export const HOTEL_SEED: HotelSeedItem[] = [
  {
    id: 'h1',
    name: 'Hotel Paradise',
    stars: 4,
    bedType: 'King',
    price: '$220',
    breakfastIncluded: true,
    image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=900&h=600&fit=crop',
    __renderDetailCard: true,
    location: 'Monterey, California',
    rating: 8.7,
    ratingLabel: 'Excellent',
    pricePerNight: 220,
    totalPrice: 880,
    nights: 4,
    amenities: ['Free WiFi', 'Pool', 'Breakfast', 'Parking'],
    description: 'Coastal stay with quick access to Cannery Row and Monterey Bay Aquarium.',
    category: 'Premium',
    rooms: [
      { id: 'h1-r1', type: 'Standard King', price: '$180', sleeps: 2, refundable: true, image: room1Img },
      { id: 'h1-r2', type: 'Deluxe Suite', price: '$280', sleeps: 3, refundable: false, image: room2Img },
      { id: 'h1-r3', type: 'Ocean View Queen', price: '$240', sleeps: 2, refundable: true, image: room3Img },
      { id: 'h1-r4', type: 'Penthouse Suite', price: '$470', sleeps: 4, refundable: false, image: room4Img },
    ]
  },
  {
    id: 'h2',
    name: 'Oceanview Lodge',
    stars: 5,
    bedType: 'Queen',
    price: '$340',
    breakfastIncluded: false,
    image: 'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=900&h=600&fit=crop',
    __renderDetailCard: true,
    location: 'Monterey, California',
    rating: 9.1,
    ratingLabel: 'Exceptional',
    pricePerNight: 340,
    totalPrice: 1360,
    nights: 4,
    amenities: ['Free WiFi', 'Sea View', 'Spa', 'Gym'],
    description: 'Oceanfront hotel with sunset decks and premium suites.',
    category: 'Luxury',
    rooms: [
      { id: 'h2-r1', type: 'Standard King', price: '$290', sleeps: 2, refundable: true, image: room1Img },
      { id: 'h2-r2', type: 'Deluxe Suite', price: '$390', sleeps: 3, refundable: false, image: room2Img },
      { id: 'h2-r3', type: 'Ocean View Queen', price: '$340', sleeps: 2, refundable: true, image: room3Img },
      { id: 'h2-r4', type: 'Penthouse Suite', price: '$580', sleeps: 4, refundable: false, image: room4Img },
    ]
  },
  {
    id: 'h3',
    name: 'Monterey Bay Resort',
    stars: 4,
    bedType: 'King',
    price: '$295',
    breakfastIncluded: true,
    image: 'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=900&h=600&fit=crop',
    __renderDetailCard: true,
    location: 'Monterey, California',
    rating: 8.9,
    ratingLabel: 'Excellent',
    pricePerNight: 295,
    totalPrice: 1180,
    nights: 4,
    amenities: ['Free WiFi', 'Breakfast', 'Pool', 'Shuttle'],
    description: 'Family-friendly resort close to beach trails and marina dining.',
    category: 'Premium',
    rooms: [
      { id: 'h3-r1', type: 'Standard King', price: '$250', sleeps: 2, refundable: true, image: room1Img },
      { id: 'h3-r2', type: 'Deluxe Suite', price: '$335', sleeps: 3, refundable: false, image: room2Img },
      { id: 'h3-r3', type: 'Ocean View Queen', price: '$280', sleeps: 2, refundable: true, image: room3Img },
      { id: 'h3-r4', type: 'Penthouse Suite', price: '$510', sleeps: 4, refundable: false, image: room4Img },
    ]
  },
  {
    id: 'h4',
    name: 'Cypress Coast Inn',
    stars: 5,
    bedType: 'Queen',
    price: '$375',
    breakfastIncluded: true,
    image: 'https://images.unsplash.com/photo-1578683010236-d716f9a3f461?w=900&h=600&fit=crop',
    __renderDetailCard: true,
    location: 'Carmel-by-the-Sea, California',
    rating: 9.3,
    ratingLabel: 'Exceptional',
    pricePerNight: 375,
    totalPrice: 1500,
    nights: 4,
    amenities: ['Free WiFi', 'Spa', 'Valet', 'Ocean Terrace'],
    description: 'Upscale retreat with private terraces and curated tasting menus.',
    category: 'Luxury',
    rooms: [
      { id: 'h4-r1', type: 'Standard King', price: '$320', sleeps: 2, refundable: true, image: room1Img },
      { id: 'h4-r2', type: 'Deluxe Suite', price: '$470', sleeps: 3, refundable: false, image: room2Img },
      { id: 'h4-r3', type: 'Ocean View Queen', price: '$390', sleeps: 2, refundable: true, image: room3Img },
      { id: 'h4-r4', type: 'Penthouse Suite', price: '$760', sleeps: 4, refundable: false, image: room4Img },
    ]
  },
  {
    id: 'h5',
    name: 'Pacific Dunes Hotel',
    stars: 4,
    bedType: 'King',
    price: '$265',
    breakfastIncluded: false,
    image: 'https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?w=900&h=600&fit=crop',
    __renderDetailCard: true,
    location: 'Pacific Grove, California',
    rating: 8.5,
    ratingLabel: 'Very Good',
    pricePerNight: 265,
    totalPrice: 1060,
    nights: 4,
    amenities: ['Free WiFi', 'Bike Rental', 'Parking', 'Pet Friendly'],
    description: 'Relaxed coastal hotel steps from ocean paths and local cafes.',
    category: 'Comfort',
    rooms: [
      { id: 'h5-r1', type: 'Standard King', price: '$210', sleeps: 2, refundable: true, image: room1Img },
      { id: 'h5-r2', type: 'Deluxe Suite', price: '$295', sleeps: 3, refundable: false, image: room2Img },
      { id: 'h5-r3', type: 'Ocean View Queen', price: '$245', sleeps: 2, refundable: true, image: room3Img },
      { id: 'h5-r4', type: 'Penthouse Suite', price: '$410', sleeps: 4, refundable: false, image: room4Img },
    ]
  }
];

